<template>
<div>
  <form-data url="api/homepages/1" method="PUT" :form="form" @success="onSubmitSuccess"></form-data>
</div>
</template>

<script>
import FormData from './FormData.vue'
import Form from './../Form'
import Flash from '../Flash'
import Api from './../api'

export default {
  name: 'Homepage',
  data () {
    return {
      form: Form.create({
        'Slogan': [
          { name: 'sloganFirst', label: 'Slogan cz. 1' },
          { name: 'sloganSecond', label: 'Slogan cz. 2 ' }
        ],
        'Statystyki': [
          { name: 'statsFirstNumber', label: 'Okno 1 liczby' },
          { name: 'statsFirstContent', label: 'Okno 1 treść' },
          { name: 'statsSecondNumber', label: 'Okno 2 liczby' },
          { name: 'statsSecondContent', label: 'Okno 2 treść' },
          { name: 'statsThirdNumber', label: 'Okno 3 liczby' },
          { name: 'statsThirdContent', label: 'Okno 3 treść' },
          { name: 'statsFourthNumber', label: 'Okno 4 liczby' },
          { name: 'statsFourthContent', label: 'Okno 4 treść' }
        ],
        'Zaproszenie': [
          { name: 'inviteHeader', label: 'Nagłówek' },
          { name: 'sellerHeader', label: 'Sprzedający - nagłówek' },
          { name: 'sellerContent', label: 'Sprzedający - treść' },
          { name: 'buyerHeader', label: 'Kupujący - nagłówek' },
          { name: 'buyerContent', label: 'Kupujący - treść' }
        ],
        'Inne': [
          { name: 'phoneTop', label: 'Telefon' }
        ]
      })
    }
  },
  components: {
    FormData
  },
  methods: {
    onSubmitSuccess () {
      Flash.success('Zaktualizowano stronę główną poprawnie')
    },
    fetchData () {
      Api.homepage.get().then(this.fetchSuccess)
    },
    fetchSuccess ({ body }) {
      this.form.setData(body)
    }
  },
  created () {
    this.fetchData()
  }
}
</script>



// WEBPACK FOOTER //
// Homepage.vue?3117e854